import { Box, Stack, IconButton } from '@mui/material';
import Typography from "@vapor/react-extended/ExtendedTypography";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

export const NavigationControls = ({ 
    currentIndex, 
    totalItems, 
    onPrevious, 
    onNext 
}) => {
    return (
        <Box sx={{ 
            mt: 2,
            backgroundColor: 'rgba(255, 255, 255, 0.7)',
            backdropFilter: 'blur(5px)'                    
        }}>
            <Typography variant="body1" sx={{ textAlign: 'center', mb: 1, fontWeight: 'bold' }}>
                Anagrafica {currentIndex + 1} / {totalItems}
            </Typography>
            
            <Stack direction="row" spacing={2} justifyContent="center" alignItems="center">
                <IconButton
                    onClick={onPrevious}
                    disabled={currentIndex === 0}
                    color="primary"
                    size="large"
                >
                    <ArrowBackIosIcon />
                </IconButton>
                
                <Box sx={{ 
                    width: '400px', 
                    height: '8px', 
                    backgroundColor: 'rgba(224, 224, 224, 0.5)',                     
                    position: 'relative'
                }}>
                    <Box sx={{
                        width: `${((currentIndex + 1) / totalItems) * 100}%`,
                        height: '100%',
                        backgroundColor: 'rgba(25, 118, 210, 0.8)',
                        borderRadius: '4px',
                        transition: 'width 0.3s ease'
                    }} />
                </Box>
                
                <IconButton
                    onClick={onNext}
                    disabled={currentIndex === totalItems - 1}
                    color="primary"
                    size="large"
                >
                    <ArrowForwardIosIcon />
                </IconButton>
            </Stack>
        </Box>
    );
};
